import { cn } from "@/lib/utils";
import { Switch } from "./switch";
import { TextInput } from "./text-input";

export interface DeadlineSetupRowProps {
  /** The deadline's display label (e.g. "Acceptance deadline"). Already localized. */
  label: string;
  /** Whether this deadline is active. When off, the row dims (`.off`) and the date is disabled. */
  enabled: boolean;
  /** Toggle the deadline on/off. */
  onToggle: (enabled: boolean) => void;
  /** The deadline date as an ISO date string (`YYYY-MM-DD`). */
  date?: string;
  /** Edit the deadline date. */
  onDateChange?: (date: string) => void;
  /** Force the whole row read-only (e.g. once the proposal is sent). */
  disabled?: boolean;
}

/**
 * One row of the proposal deadline-setup list (TW-3444): a toggle, a label, and a trailing date input.
 * Flipping the switch off dims the row (`.off`) and disables the date — the operator turns each
 * adaptive deadline on/off and dates the active ones. Previously inline in ProposalTab; extracted so
 * the same row renders identically wherever deadlines are configured. Composes the kit Switch +
 * TextInput. Styling: `.dl-setup-row` / `.dls-label` / `.off`.
 */
export function DeadlineSetupRow({
  label,
  enabled,
  onToggle,
  date,
  onDateChange,
  disabled,
}: DeadlineSetupRowProps) {
  return (
    <div className={cn("dl-setup-row", !enabled && "off")}>
      <Switch checked={enabled} onChange={onToggle} label={label} disabled={disabled} />
      <span className="dls-label">{label}</span>
      <TextInput
        type="date"
        inputClassName="mono"
        value={date}
        onChange={onDateChange}
        disabled={disabled || !enabled}
      />
    </div>
  );
}
